import { apiSlice } from './apiSlice';

export const searchApiSlice = apiSlice.injectEndpoints({
	endpoints: (builder) => ({
		globalSearch: builder.query({
			query: ({ q, limit = 10 }) => ({
				url: '/api/search',
				params: { q, limit },
			}),
			keepUnusedDataFor: 60, // 缓存60秒，提高性能
			// 提供缓存标签，方便后续管理
			providesTags: (result, error, { q }) => [{ type: 'Search', id: q }],
		}),
	}),
});

export const { useGlobalSearchQuery } = searchApiSlice;
